import client from './client';

export interface TransportRoute {
  id: number;
  number: string;
  name_kk?: string;
  name_ru?: string;
  is_active: boolean;
  /**
   * ВНИМАНИЕ: это НЕ текст. Легаси-словарь, в котором Flutter-сборки в проде
   * читают полилинии маршрута (schedule.directions[].track). Не перезаписывать.
   */
  schedule?: Record<string, unknown> | null;
  geometry_meta?: Record<string, unknown> | null;
  stops_count: number;
}

export interface TransportStop {
  id: number;
  name_kk?: string;
  name_ru?: string;
  latitude?: number;
  longitude?: number;
  route_count?: number;
}

export interface RouteCreatePayload {
  number: string;
  name_kk?: string;
  name_ru?: string;
  is_active?: boolean;
}

export interface StopCreatePayload {
  name_kk?: string;
  name_ru?: string;
  latitude: number;
  longitude: number;
}

export interface StopInRoute extends TransportStop {
  stop_order: number;
  direction?: 'forward' | 'reverse' | string | null;
}

export interface RouteDetail extends TransportRoute {
  stops: StopInRoute[];
  geometry_geojson?: { type: string; coordinates: [number, number][] } | null;
  geometry_meta?: {
    source?: string;
    directions?: { id?: string; type?: string; track?: [number, number][] }[];
  } | null;
}

export const transportApi = {
  // Routes
  listRoutes: () =>
    client.get<TransportRoute[]>('/api/admin/transport/routes'),

  /** Детали маршрута с остановками и геометрией (публичная ручка). */
  getRouteDetail: (id: number) =>
    client.get<RouteDetail>(`/api/v1/transport/routes/${id}`),

  /** Полная замена состава маршрута (порядок обоих направлений). */
  replaceRouteStops: (routeId: number, stops: { stop_id: number; stop_order: number; direction: string }[]) =>
    client.put(`/api/admin/transport/routes/${routeId}/stops`, { stops }),

  createRoute: (data: RouteCreatePayload) =>
    client.post<TransportRoute>('/api/admin/transport/routes', data),

  updateRoute: (id: number, data: Partial<RouteCreatePayload>) =>
    client.patch<TransportRoute>(`/api/admin/transport/routes/${id}`, data),

  deleteRoute: (id: number) =>
    client.delete(`/api/admin/transport/routes/${id}`),

  // Stops
  listStops: () =>
    client.get<TransportStop[]>('/api/admin/transport/stops'),

  createStop: (data: StopCreatePayload) =>
    client.post<TransportStop>('/api/admin/transport/stops', data),

  updateStop: (id: number, data: Partial<StopCreatePayload>) =>
    client.patch<TransportStop>(`/api/admin/transport/stops/${id}`, data),

  deleteStop: (id: number) =>
    client.delete(`/api/admin/transport/stops/${id}`),

  // Route-Stop links
  addStopToRoute: (routeId: number, stopId: number, stopOrder: number, direction?: string) =>
    client.post(`/api/admin/transport/routes/${routeId}/stops`, {
      stop_id: stopId,
      stop_order: stopOrder,
      direction: direction || 'forward',
    }),

  removeStopFromRoute: (routeId: number, stopId: number) =>
    client.delete(`/api/admin/transport/routes/${routeId}/stops/${stopId}`),

  // Trains
  listTrains: () => client.get<TrainSchedule[]>('/api/admin/transport/trains'),
  createTrain: (data: TrainCreatePayload) => client.post<TrainSchedule>('/api/admin/transport/trains', data),
  updateTrain: (id: number, data: Partial<TrainCreatePayload>) =>
    client.patch<TrainSchedule>(`/api/admin/transport/trains/${id}`, data),
  deleteTrain: (id: number) => client.delete(`/api/admin/transport/trains/${id}`),
};

export interface TrainSchedule {
  id: number;
  train_number: string;
  route_name_ru: string;
  route_name_kk?: string | null;
  from_station: string;
  to_station: string;
  departure_time: string;
  arrival_time?: string | null;
  days_of_week: string;
  train_type: string;
  note_ru?: string | null;
  note_kk?: string | null;
  is_active: boolean;
}

export interface TrainCreatePayload {
  train_number: string;
  route_name_ru: string;
  route_name_kk?: string;
  from_station: string;
  to_station: string;
  departure_time: string;
  arrival_time?: string;
  days_of_week?: string;
  train_type?: string;
  note_ru?: string;
  note_kk?: string;
  is_active?: boolean;
}
